import type { ReactNode } from "react";

type Props = {
  title?: string;
  description?: string;
  children: ReactNode;
  open?: boolean;
  className?: string;
  footer?: ReactNode;
  onClose?: () => void;
  closeLabel?: string;
};

/**
 * Inspect panel primitive — deliberate detail surface (V1C).
 * Domain summaries keep item identity; this wraps section chrome.
 */
export function InspectPanel({
  title,
  description,
  children,
  open = true,
  className = "",
  footer,
  onClose,
  closeLabel = "بستن",
}: Props) {
  if (!open) return null;

  return (
    <aside
      className={`inspect-panel ${className}`.trim()}
      data-vt-inspect-panel
      aria-label={title}
    >
      {(title || description || onClose) && (
        <header className="inspect-panel__header">
          <div className="inspect-panel__heading">
            {title && <h2 className="inspect-panel__title">{title}</h2>}
            {description && <p className="inspect-panel__description">{description}</p>}
          </div>
          {onClose && (
            <button
              type="button"
              className="btn btn--ghost btn--sm inspect-panel__close"
              onClick={onClose}
            >
              {closeLabel}
            </button>
          )}
        </header>
      )}
      <div className="inspect-panel__body">{children}</div>
      {footer && <footer className="inspect-panel__footer">{footer}</footer>}
    </aside>
  );
}
